import { NgModule, ModuleWithProviders } from '@angular/core';

import { RouterModule } from '@angular/router'

import { SharedModule } from '../shared/shared.module'

import { PagesRoutingModule } from './pages-routing.module';
import { PageContainerComponent } from './containers/page-container/page-container.component';
import { PagePageComponent } from './components/page-page/page-page.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule
  ],
  declarations: [
    PageContainerComponent,
    PagePageComponent
  ],
  entryComponents: [
    PageContainerComponent
  ]
})
export class PagesModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: RootPagesModule,
      providers: []
    }
  }
 }

@NgModule({
  imports: [
    PagesModule,
    PagesRoutingModule
  ]
})
export class RootPagesModule  { }
